module.exports = __webpack_public_path__ + "assets/media/grafitti-texture.444e6598.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/grafitti-texture.svg
// module id = 116
// module chunks = 0